import React, { Component } from 'react';

import { SCREEN_ID_NOT_FOUND } from 'client/constants/screenIds';
import { URL_IABS } from 'client/constants/urls';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@withScreenId(SCREEN_ID_NOT_FOUND)
@withScrollToTop
class NotFound extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Rent the best homes in Texas | Sunroom Rentals',
    section: '404',
    keywords: 'rent, home, austin, tour, apartment',
    description: (
      'Spend less time scheduling tours, our rental experts will ' +
      'schedule and confirm tours for you.'
    ),
    image: 'https://sunroomrentals.com/images/metadata/og-house.jpg',
  })

  render() {

    return (
      <div className='page-landing notFound'>
        <div id='navbar' className='clearfix'>
          <SrLink to='/' id='logo' />
          <SrLink to='/login' id='login'>Log In</SrLink>
        </div>

        <div className='hero'>
          <div className='column-left'>
            <h1>Whoops, that page doesn't exist</h1>
            <h2>Let's get you back in</h2>
            <SrLink to='/start' className='button yellow cta'>look for homes!</SrLink>
          </div>
          <div className='column-right'>
            <span id='hero-image' />
          </div>
        </div>

        <div className='section tagline'>
          <span className='one-liner'>Sunroom will schedule tours for you, 100%&nbsp;free.</span>
        </div>

        <div className='footer'>
          <span>Made with ❤ in Austin, TX.</span>
          <br />
          <span>
            Want to work with us? Apply on our
            <SrLink to='https://sunroom.recruitee.com/' target='_blank'>careers page</SrLink>
            .
          </span>
          <br />
          <br />
          <br />
          <div>
            <span>
              <SrLink
                to={URL_IABS}
                target='_blank'
              >
                IABS
              </SrLink>
              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              <SrLink to='https://www.trec.texas.gov/forms/consumer-protection-notice' target='_blank'>
                TREC Consumer Protection
              </SrLink>
            </span>
          </div>
          <div>
            <span>TREC #9007204&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;help@sunroomrentals.com</span>
          </div>
          <span className='attribution'>
            Based on information from the Austin Board of REALTORS® for the period through
            today. All listing information is deemed reliable but is not guaranteed and should
            be independently verified. The Austin Board of REALTORS®, ACTRIS and their
            affiliates provide the MLS and all content therein “AS IS” and without any warranty,
            express or implied. Listing information is provided exclusively for consumers’ personal,
            non-commercial use and may not be used for any purpose other than to identify prospective
            properties consumers may be interested in purchasing.
          </span>
        </div>
      </div>
    );
  }
}

NotFound.displayName = 'NotFound';

export default NotFound;
